// extracted by mini-css-extract-plugin
module.exports = {"cost-saving-D":"D_cost-saving-D__oRS2o"};